// extracted by mini-css-extract-plugin
export default {"root":"Ootd_root__CVXnE","section":"Ootd_section__MDolJ","title":"Ootd_title__zs4DA","text":"Ootd_text__kUeMu"};